import authAxios from "../utility/authAxios";
import {API_VERSION, SAAS_SERVICE_PATH} from "../config/axios";
import {disabledCache, enableHeaderCache} from "../utility/utils";

const API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/company`;
const CONFIG_API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/company-config`;

export const getAll = async () => {
    return authAxios.get(`${API_URI}`);
};

export const getCompany = async (id, cache = false) => {
    if(id) {
        return authAxios.get(`${API_URI}/${id}`, enableHeaderCache(cache));
    }
};

export const createCompany = async (data) => {
    return authAxios.post(`${API_URI}`, data);
};

export const companyUpdate = async (id, data) => {
    return authAxios.put(`${API_URI}/${id}`, data);
};

export const deleteCompany = async (id) => {
    return authAxios.delete(`${API_URI}/${id}`);
};

export const getCompanyConfigs = async (id) => {
    if(id) {
        const response = await authAxios.get(`${API_URI}/${id}`);
        return response?.data?.data?.company_configurations ?? {};
    }
    return {}
};

export const getSingleCompanyConfigs = async (id) => {
    const response = await authAxios.get(`${CONFIG_API_URI}/single/${id}`);
    return response?.data?.data;
};

export const createCompanyConfigs = async (companyId, data) => {
    return authAxios.post(`${CONFIG_API_URI}/${companyId}`, data);
};

export const updateCompanyConfigs = async (companyId, data) => {
    return authAxios.put(`${CONFIG_API_URI}/${companyId}`, data);
};
